import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { posthogService } from '@/services/posthog-service';

/**
 * Fires a PostHog `$pageview` event on every React Router location change.
 * Mount once in App.tsx inside the BrowserRouter context.
 *
 * PostHog autocapture is off for pageviews (capture_pageview: false in init)
 * so this hook is the single source for page view tracking.
 */
export function usePageView(): void {
  const location = useLocation();

  useEffect(() => {
    posthogService.track('$pageview', {
      $current_url: window.location.href,
      pathname: location.pathname,
    });
  }, [location.pathname, location.search]);
}
